export default __webpack_public_path__ + "static/media/torso-top-left-side.4adc0fdf.png";